/**
 * Inventory-backed browse mega-menu tree from GET /api/browse-menu.
 * Subcategories with zero matching events/listings are omitted server-side.
 */

const parseDiscoveryEnabled = () => {
  const raw = process.env.REACT_APP_PROMOTIX_DISCOVERY_PRIMARY_EVENTS;
  if (raw == null || raw === '') {
    return false;
  }
  const normalized = String(raw).trim().toLowerCase();
  return normalized === 'true' || normalized === '1' || normalized === 'yes';
};

export const isBrowseMenuInventoryEnabled = () => parseDiscoveryEnabled();

export const fetchBrowseMenuTree = async () => {
  if (!isBrowseMenuInventoryEnabled()) {
    return null;
  }
  const base =
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : '';
  const res = await fetch(`${base}/api/browse-menu`, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) {
    throw new Error(`browse-menu ${res.status}`);
  }
  const data = await res.json();
  return Array.isArray(data?.categories) ? data.categories : [];
};
